import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { Shield } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) nav("/app");
    else setError(res.error || "Login failed");
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-6 py-12">
      <div className="w-full max-w-md rounded-xl border border-[#212A3E] bg-[#101623] p-8 shadow-2xl">
        <div className="mb-8 flex items-center gap-2">
          <Shield className="h-5 w-5 text-[#D4AF37]" />
          <span className="font-serif-display text-xl text-white">RPG<span className="text-[#D4AF37]">me</span></span>
        </div>
        <h1 className="font-serif-display text-3xl font-light text-white">Welcome back.</h1>
        <p className="mt-2 text-sm text-[#A0ABC0]">Sign in to pick up your sheet where you left it.</p>

        <form className="mt-8 space-y-5" onSubmit={submit} data-testid="login-form">
          <div>
            <Label className="text-[#A0ABC0]">Email</Label>
            <Input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 border-[#212A3E] bg-[#070A11] text-white focus-visible:ring-[#D4AF37]"
              data-testid="login-email-input" placeholder="you@realm.com"
            />
          </div>
          <div>
            <Label className="text-[#A0ABC0]">Password</Label>
            <Input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 border-[#212A3E] bg-[#070A11] text-white focus-visible:ring-[#D4AF37]"
              data-testid="login-password-input" placeholder="••••••••"
            />
          </div>
          {error && (
            <p className="rounded border border-red-500/40 bg-red-950/40 p-3 text-sm text-red-300" data-testid="login-error">
              {error}
            </p>
          )}
          <Button disabled={busy} className="w-full bg-[#D4AF37] text-[#0b0f18] hover:bg-[#e7c75a]" data-testid="login-submit-btn">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-[#A0ABC0]">
          New here?{" "}
          <Link to="/register" className="text-[#D4AF37] hover:underline" data-testid="login-to-register-link">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
